define.alias("shared/components/shared/publish/switcher/item/info-text", "settings/components/shared/publish/switcher/item/info-text");